import {useEffect, useState} from "react";
import {ThinChevronRight, ThinCloseIcon, ThinJobIcon} from "../../../components/icons/material-icons";
import {HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import {AuthRedirectAdmins, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {ShowSnackbar} from "../../../components/template/snackbar";
import {CurrencyFormat} from "../../../components/techaran/money";

interface jobInterface {
    id: number,
    title: string,
    isTeacher: boolean,
    count: number,
}

export const AdminsStaffSetJobModal = (props: { active: boolean, closeHandler: any, staffId:string,onDone:any }) => {
    const [list, setList] = useState<jobInterface[]>([]);
    const fetchList = () => {
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/admins/staff/jobs/list',
            {},
            true,
            (d: {
                result: string,
                reason: string,
                list: jobInterface[] | null
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                setList(d.list === null ? [] : d.list);
            },
            () => {
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    useEffect(() => {
        const isActive = props.active;
        if (isActive) {
            document.body.classList.add("body-no-scroll");
            fetchList();
        } else {
            document.body.classList.remove('body-no-scroll')
        }
    }, [props.active]);
    const saveJob = (job:number) => {
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/admins/staff/details/set-job',
            {
                id:props.staffId,
                job:job.toString(),
            },
            true,
            (d: {
                result: string,
                reason: string,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                ShowSnackbar(
                    'شغل این همکار تغییر یافت.',
                    'باشه',
                    5000,
                );
                props.closeHandler();
                props.onDone();
            },
            () => {
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    return (
        <>
            <div className={"web-modal-overlay" + (props.active ? ' active' : '')} onClick={props.closeHandler}/>
            <div className={"web-modal" + (props.active ? ' active' : '')} style={{top:20}}>
                <div className="web-modal-header">
                    <div><b>انتخاب شغل</b></div>
                    <button onClick={props.closeHandler}><ThinCloseIcon/></button>
                </div>
                <div className="web-modal-body">
                    <div className="add-student">
                        <span className="d-block" style={{margin:'5px 0 20px 0'}}>
                            لطفا یک شغل را برای این همکار انتخاب نمایید:
                        </span>
                        {
                            list.map((s,i)=>
                                <button key={"J28SiPickJob-23395_" + i}
                                        onClick={()=>saveJob(s.id)}
                                        className="normal-list-tile">
                                    <div>
                                        <i><ThinJobIcon/></i>
                                        <div>
                                            <b>{s.title}</b>
                                            <span>شامل {CurrencyFormat(s.count)} نفر</span>
                                        </div>
                                    </div>
                                    <ThinChevronRight/>
                                </button>
                            )
                        }
                    </div>
                </div>
            </div>
        </>
    );
};